import { Component, OnInit, OnDestroy, input, inject, output } from "@angular/core";
import { ClozeTestStyleModel } from "../model/cloze-test-style-model";
import { TestResultDto } from "gast-onset-ng2";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { NgClass, NgStyle, PercentPipe } from "@angular/common";
import { ExerciseIndicatorComponent } from "../exercise-indicator/exercise-indicator.component";

@Component({
  selector: "cloze-test-result",
  templateUrl: "./test-result.component.html",
  styleUrls: ["./test-result.component.scss"],
  standalone: true,
  imports: [ExerciseIndicatorComponent, NgStyle, NgClass, TranslatePipe, PercentPipe],
})
export class TestResultComponent implements OnInit, OnDestroy {
  readonly #route = inject(ActivatedRoute);
  readonly #ngxTranslate = inject(TranslateService);

  readonly results = input<TestResultDto>({} as TestResultDto);
  readonly showResult = input(false);
  readonly clozeTestStyleModel = input<ClozeTestStyleModel>({} as ClozeTestStyleModel);
  readonly cTestLogo = input("");
  readonly cTestButtonColor = input<string>("");
  readonly mobileMode = input(false);
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);
  readonly showEndTestButton = input(false);
  readonly lang = input("de");
  readonly clozeTest = output<boolean>();

  readonly #subscription = new Subscription();

  ngOnDestroy(): void {
    this.#subscription.unsubscribe();
  }

  ngOnInit() {
    const langSub = this.#route.queryParams.subscribe((params) => {
      if (params["lang"]) {
        const lang = params["lang"] as string;
        this.#ngxTranslate.use(lang.toLowerCase());
      }
    });
    this.#subscription.add(langSub);
  }

  onClozeTest() {
    this.clozeTest.emit(true);
  }

closeTab() {
    window.close();
  }

}
